<!-- 模板 -->
<template>
  <div class="headers">
    <div class="navTop_box">
      <div class="wrap">
        <p>
          <a alt="访问我的专属空间" @click="show = true">访问我的专属空间</a>
          <a
            href="https://rsj.beijing.gov.cn/fuwu/zxbs/grbs/"
            target="_blank"
            alt="个人办事"
            >个人办事</a
          ><a
            href="https://rsj.beijing.gov.cn/fuwu/zxbs/frbs/"
            target="_blank"
            alt="法人办事"
            >法人办事</a
          ><a alt="北京政务服务网" @click="show2 = true">北京政务服务网</a>
          <a id="zh_click_s" href="javascript:zh_tran('s');">简</a>
          <a id="zh_click_t" href="javascript:zh_tran('t');">繁</a>
          <a
            href="https://fuwu.rsj.beijing.gov.cn/zhrs/jingxiaobao/"
            target="_blank"
            alt="智能问答"
            >智能问答</a
          >
          <a
            href="http://rsj.beijing.gov.cn/ydb/index.html"
            target="_blank"
            alt="移动版"
            >移动版</a
          >
          <!-- <a id="zh_click_s" href="javascript:zh_tran('s',2);">简</a>
    <a id="zh_click_t" href="javascript:zh_tran('t',2);">繁</a> -->
          <!--<a href="https://mail.beijing.gov.cn/" target="_blank" alt="政务邮箱">政务邮箱</a>-->
          <a
            class="R_float"
            href="javascript:void(0)"
            id="cniil_wza"
            onclick="aria.start()"
            for="wza"
            >网站无障碍</a
          >
        </p>
      </div>
    </div>
    <header>
      <div class="header-top">
        <div class="wrap">
          <h1>
            <router-link to="/"
              ><img src="../assets/rsjlogo.png" alt="" class="logo"
            /></router-link>
          </h1>
        </div>
      </div>
      <div class="header-bottom">
        <div class="wrap">
          <h2>
            北京市专业技术人才知识更新工程
            <a href="http://www.beijing.gov.cn" target="_blank"
              ><img src="@/assets/window.png" alt=""
            /></a>
          </h2>
          <div class="search-box">
            <input type="text" placeholder="输入关键词搜索" v-model="title" />
            <div class="search-btn" @click="toSearch">搜索</div>
          </div>
          <img src="../assets/tiantan.png" alt="" class="tiantan" />
        </div>
      </div>
    </header>
    <!-- 北京政务登录弹 -->
    <div
      id="cont_cqhlxjfzw"
      class="contcqhlxjfzw"
      style="display: inline"
      v-if="show2"
    >
      <div align="center">
        <p style="text-align: center; font-size: 20px">温馨提醒</p>
        <p align="left" style="text-indent: 2em">
          您即将离开北京市人力资源和社会保障局网，进入北京政务服务网。
        </p>
      </div>
      <a
        style="color: red; float: right"
        href="javascript:void(0)"
        @click="show2 = false"
        ><span>关闭&nbsp;&nbsp;</span
        ><!-- a--> </a
      ><a
        style="color: red; float: right"
        target="_blank"
        href="http://banshi.beijing.gov.cn/"
        >点击进入&nbsp;&nbsp;</a
      >
    </div>
    <div id="cont_cqhlxjfgrzx" class="contcqhlxjfzw" v-if="show">
      <div align="center">
        <p style="font-size: 20px">温馨提醒</p>
        <p align="left" style="text-indent: 2em">
          您访问的链接即将跳转到首都之窗个人中心，如需办理人社业务请登录<a
            style="color: red"
            href="http://bjt.beijing.gov.cn/renzheng/open/login/goUserLogin?client_id=2117&amp;redirect_uri=http://fuwu.rsj.beijing.gov.cn/bjtsso/third/redirect&amp;response_type=code&amp;scope=user_info&amp;state="
            target="_blank"
            alt="个人登录"
            >&nbsp;<b>个人办事</b></a
          >
          或
          <a
            style="color: red"
            href="http://fuwu.rsj.beijing.gov.cn/unitplatform/yztLoginService"
            target="_blank"
            alt="个人登录"
            ><b>法人办事</b>。</a
          >
        </p>
      </div>
      <div style="margin-top: 10px">
        <a style="color: red; float: right" @click="show = false"
          ><span>关闭&nbsp;&nbsp;</span
          ><!-- a--> </a
        ><a
          style="color: red; float: right"
          target="_blank"
          href="https://bjt.beijing.gov.cn/renzheng/open/login/goUserLogin?client_id=100100001058&amp;redirect_uri=https://banshi.beijing.gov.cn/bjspacenew/web/login/sso/person/in&amp;response_type=code&amp;scope=user_info&amp;state="
          >点击进入首都之窗“访问我的专属空间”&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a
        >
      </div>
    </div>
  </div>
</template>
<script>
// import request from '../utils/request.js'
export default {
  name: "Header",
  data() {
    return {
      title: "",
      show: false,
      show2: false,
      // 原脚本配置参数（迁移到data中，改为响应式）
      zhDefault: "n", // 默认语言（不修改）
      currentChoose: "s", // 当前选择的字体（替代原zh_choose）
      zhClass: "zh_click", // 原链接class名（保留，用于兼容样式）
      styleActive: "font-weight:bold; color:green;", // 选中样式
      styleInactive: "color:blue;", // 未选中样式
      // 简繁字库（原zh_s/zh_t，直接迁移）
      zhS: "皑蔼碍爱翱袄奥坝罢摆败颁办绊帮绑镑谤剥饱宝报鲍辈贝钡狈备惫绷笔毕毙闭边编贬变辩辫鳖瘪濒滨宾摈饼拨钵铂驳卜补参蚕残惭惨灿苍舱仓沧厕侧册测层诧搀掺蝉馋谗缠铲产阐颤场尝长偿肠厂畅钞车彻尘陈衬撑称惩诚骋痴迟驰耻齿炽冲虫宠畴踌筹绸丑橱厨锄雏础储触处传疮闯创锤纯绰辞词赐聪葱囱从丛凑窜错达带贷担单郸掸胆惮诞弹当挡党荡档捣岛祷导盗灯邓敌涤递缔点垫电淀钓调迭谍叠钉顶锭订东动栋冻斗犊独读赌镀锻断缎兑队对吨顿钝夺鹅额讹恶饿儿尔饵贰发罚阀珐矾钒烦范贩饭访纺飞废费纷坟奋愤粪丰枫锋风疯冯缝讽凤肤辐抚辅赋复负讣妇缚该钙盖干赶秆赣冈刚钢纲岗皋镐搁鸽阁铬个给龚宫巩贡钩沟构购够蛊顾剐关观馆惯贯广规硅归龟闺轨诡柜贵刽辊滚锅国过骇韩汉阂鹤贺横轰鸿红后壶护沪户哗华画划话怀坏欢环还缓换唤痪焕涣黄谎挥辉毁贿秽会烩汇讳诲绘荤浑伙获货祸击机积饥讥鸡绩缉极辑级挤几蓟剂济计记际继纪夹荚颊贾钾价驾歼监坚笺间艰缄茧检碱硷拣捡简俭减荐槛鉴践贱见键舰剑饯渐溅涧浆蒋桨奖讲酱胶浇骄娇搅铰矫侥脚饺缴绞轿较秸阶节茎惊经颈静镜径痉竞净纠厩旧驹举据锯惧剧鹃绢杰洁结诫届紧锦仅谨进晋烬尽劲荆觉决诀绝钧军骏开凯颗壳课垦恳抠库裤夸块侩宽矿旷况亏岿窥馈溃扩阔蜡腊莱来赖蓝栏拦篮阑兰澜谰揽览懒缆烂滥捞劳涝乐镭垒类泪篱离里鲤礼丽厉励砾历沥隶俩联莲连镰怜涟帘敛脸链恋炼练粮凉两辆谅疗辽镣猎临邻鳞凛赁龄铃凌灵岭领馏刘龙聋咙笼垄拢陇楼娄搂篓芦卢颅庐炉掳卤虏鲁赂禄录陆驴吕铝侣屡缕虑滤绿峦挛孪滦乱抡轮伦仑沦纶论萝罗逻锣箩骡骆络妈玛码蚂马骂吗买麦卖迈脉瞒馒蛮满谩猫锚铆贸么霉没镁门闷们锰梦谜弥觅绵缅庙灭悯闽鸣铭谬谋亩钠纳难挠脑恼闹馁腻撵捻酿鸟聂啮镊镍柠狞宁拧泞钮纽脓浓农疟诺欧鸥殴呕沤盘庞国爱赔喷鹏骗飘频贫苹凭评泼颇扑铺朴谱脐齐骑岂启气弃讫牵扦钎铅迁签谦钱钳潜浅谴堑枪呛墙蔷强抢锹桥乔侨翘窍窃钦亲轻氢倾顷请庆琼穷趋区躯驱龋颧权劝却鹊让饶扰绕热韧认纫荣绒软锐闰润洒萨鳃赛伞丧骚扫涩杀纱筛晒闪陕赡缮伤赏烧绍赊摄慑设绅审婶肾渗声绳胜圣师狮湿诗尸时蚀实识驶势释饰视试寿兽枢输书赎属术树竖数帅双谁税顺说硕烁丝饲耸怂颂讼诵擞苏诉肃虽绥岁孙损笋缩琐锁獭挞抬摊贪瘫滩坛谭谈叹汤烫涛绦腾誊锑题体屉条贴铁厅听烃铜统头图涂团颓蜕脱鸵驮驼椭洼袜弯湾顽万网韦违围为潍维苇伟伪纬谓卫温闻纹稳问瓮挝蜗涡窝呜钨乌诬无芜吴坞雾务误锡牺袭习铣戏细虾辖峡侠狭厦锨鲜纤咸贤衔闲显险现献县馅羡宪线厢镶乡详响项萧销晓啸蝎协挟携胁谐写泻谢锌衅兴汹锈绣虚嘘须许绪续轩悬选癣绚学勋询寻驯训讯逊压鸦鸭哑亚讶阉烟盐严颜阎艳厌砚彦谚验鸯杨扬疡阳痒养样瑶摇尧遥窑谣药爷页业叶医铱颐遗仪彝蚁艺亿忆义诣议谊译异绎荫阴银饮樱婴鹰应缨莹萤营荧蝇颖哟拥佣痈踊咏涌优忧邮铀犹游诱舆鱼渔娱与屿语吁御狱誉预驭鸳渊辕园员圆缘远愿约跃钥岳粤悦阅云郧匀陨运蕴酝晕韵杂灾载攒暂赞赃脏凿枣灶责择则泽贼赠扎札轧铡闸诈斋债毡盏斩辗崭栈战绽张涨帐账胀赵蛰辙锗这贞针侦诊镇阵挣睁狰帧郑证织职执纸挚掷帜质钟终种肿众诌轴皱昼骤猪诸诛烛瞩嘱贮铸筑驻专砖转赚桩庄装妆壮状锥赘坠缀谆浊兹资渍踪综总纵邹诅组钻致钟么为只凶准启板里雳余链泄",
      zhT: "皚藹礙愛翺襖奧壩罷擺敗頒辦絆幫綁鎊謗剝飽寶報鮑輩貝鋇狽備憊繃筆畢斃閉邊編貶變辯辮鼈癟瀕濱賓擯餅撥缽鉑駁蔔補參蠶殘慚慘燦蒼艙倉滄廁側冊測層詫攙摻蟬饞讒纏鏟産闡顫場嘗長償腸廠暢鈔車徹塵陳襯撐稱懲誠騁癡遲馳恥齒熾沖蟲寵疇躊籌綢醜櫥廚鋤雛礎儲觸處傳瘡闖創錘純綽辭詞賜聰蔥囪從叢湊竄錯達帶貸擔單鄲撣膽憚誕彈當擋黨蕩檔搗島禱導盜燈鄧敵滌遞締點墊電澱釣調叠諜疊釘頂錠訂東動棟凍鬥犢獨讀賭鍍鍛斷緞兌隊對噸頓鈍奪鵝額訛惡餓兒爾餌貳發罰閥琺礬釩煩範販飯訪紡飛廢費紛墳奮憤糞豐楓鋒風瘋馮縫諷鳳膚輻撫輔賦複負訃婦縛該鈣蓋幹趕稈贛岡剛鋼綱崗臯鎬擱鴿閣鉻個給龔宮鞏貢鈎溝構購夠蠱顧剮關觀館慣貫廣規矽歸龜閨軌詭櫃貴劊輥滾鍋國過駭韓漢閡鶴賀橫轟鴻紅後壺護滬戶嘩華畫劃話懷壞歡環還緩換喚瘓煥渙黃謊揮輝毀賄穢會燴彙諱誨繪葷渾夥獲貨禍擊機積饑譏雞績緝極輯級擠幾薊劑濟計記際繼紀夾莢頰賈鉀價駕殲監堅箋間艱緘繭檢堿鹼揀撿簡儉減薦檻鑒踐賤見鍵艦劍餞漸濺澗漿蔣槳獎講醬膠澆驕嬌攪鉸矯僥腳餃繳絞轎較稭階節莖驚經頸靜鏡徑痙競淨糾廄舊駒舉據鋸懼劇鵑絹傑潔結誡屆緊錦僅謹進晉燼盡勁荊覺決訣絕鈞軍駿開凱顆殼課墾懇摳庫褲誇塊儈寬礦曠況虧巋窺饋潰擴闊蠟臘萊來賴藍欄攔籃闌蘭瀾讕攬覽懶纜爛濫撈勞澇樂鐳壘類淚籬離裏鯉禮麗厲勵礫曆瀝隸倆聯蓮連鐮憐漣簾斂臉鏈戀煉練糧涼兩輛諒療遼鐐獵臨鄰鱗凜賃齡鈴淩靈嶺領餾劉龍聾嚨籠壟攏隴樓婁摟簍蘆盧顱廬爐擄鹵虜魯賂祿錄陸驢呂鋁侶屢縷慮濾綠巒攣孿灤亂掄輪倫侖淪綸論蘿羅邏鑼籮騾駱絡媽瑪碼螞馬罵嗎買麥賣邁脈瞞饅蠻滿謾貓錨鉚貿麽黴沒鎂門悶們錳夢謎彌覓綿緬廟滅憫閩鳴銘謬謀畝鈉納難撓腦惱鬧餒膩攆撚釀鳥聶齧鑷鎳檸獰甯擰濘鈕紐膿濃農瘧諾歐鷗毆嘔漚盤龐國愛賠噴鵬騙飄頻貧蘋憑評潑頗撲鋪樸譜臍齊騎豈啓氣棄訖牽扡釺鉛遷簽謙錢鉗潛淺譴塹槍嗆牆薔強搶鍬橋喬僑翹竅竊欽親輕氫傾頃請慶瓊窮趨區軀驅齲顴權勸卻鵲讓饒擾繞熱韌認紉榮絨軟銳閏潤灑薩鰓賽傘喪騷掃澀殺紗篩曬閃陝贍繕傷賞燒紹賒攝懾設紳審嬸腎滲聲繩勝聖師獅濕詩屍時蝕實識駛勢釋飾視試壽獸樞輸書贖屬術樹豎數帥雙誰稅順說碩爍絲飼聳慫頌訟誦擻蘇訴肅雖綏歲孫損筍縮瑣鎖獺撻擡攤貪癱灘壇譚談歎湯燙濤縧騰謄銻題體屜條貼鐵廳聽烴銅統頭圖塗團頹蛻脫鴕馱駝橢窪襪彎灣頑萬網韋違圍爲濰維葦偉僞緯謂衛溫聞紋穩問甕撾蝸渦窩嗚鎢烏誣無蕪吳塢霧務誤錫犧襲習銑戲細蝦轄峽俠狹廈鍁鮮纖鹹賢銜閑顯險現獻縣餡羨憲線廂鑲鄉詳響項蕭銷曉嘯蠍協挾攜脅諧寫瀉謝鋅釁興洶鏽繡虛噓須許緒續軒懸選癬絢學勳詢尋馴訓訊遜壓鴉鴨啞亞訝閹煙鹽嚴顔閻豔厭硯彥諺驗鴦楊揚瘍陽癢養樣瑤搖堯遙窯謠藥爺頁業葉醫銥頤遺儀彜蟻藝億憶義詣議誼譯異繹蔭陰銀飲櫻嬰鷹應纓瑩螢營熒蠅穎喲擁傭癰踴詠湧優憂郵鈾猶遊誘輿魚漁娛與嶼語籲禦獄譽預馭鴛淵轅園員圓緣遠願約躍鑰嶽粵悅閱雲鄖勻隕運蘊醞暈韻雜災載攢暫贊贓髒鑿棗竈責擇則澤賊贈紮劄軋鍘閘詐齋債氈盞斬輾嶄棧戰綻張漲帳賬脹趙蟄轍鍺這貞針偵診鎮陣掙睜猙幀鄭證織職執紙摯擲幟質鍾終種腫衆謅軸皺晝驟豬諸誅燭矚囑貯鑄築駐專磚轉賺樁莊裝妝壯狀錐贅墜綴諄濁茲資漬蹤綜總縱鄒詛組鑽緻鐘麼為隻兇準啟闆裡靂餘鍊洩",
    };
  },
  props: [],
  components: {},
  computed: {},
  filters: {},
  methods: {
    toSearch() {
      if (!this.title) {
        alert("请输入关键词搜索");
      }
      this.$router.push({
        path: "/search",
        query: { title: this.title },
      });
      this.title = "";
    },
    // 1. 简繁转换核心方法（替代原String.prototype.tran）
    tranStr(str) {
      let s1, s2;
      if (this.currentChoose === "t") {
        s1 = this.zhS; // 简体→繁体：以简体为源，繁体为目标
        s2 = this.zhT;
      } else if (this.currentChoose === "s") {
        s1 = this.zhT; // 繁体→简体：以繁体为源，简体为目标
        s2 = this.zhS;
      } else {
        return str; // 默认语言，不转换
      }

      let result = "";
      for (let i = 0; i < str.length; i++) {
        const c = str.charAt(i);
        const index = s1.indexOf(c);
        result += index < 0 ? c : s2.charAt(index); // 未匹配到的字符原样返回
      }
      return result;
    },

    // 2. 递归转换页面所有文本（替代原zh_tranBody）
    zhTranBody(obj) {
      const o = obj ? obj.childNodes : document.body.childNodes;
      for (let i = 0; i < o.length; i++) {
        const c = o.item(i);
        // 跳过不需要转换的标签
        if ("||BR|HR|TEXTAREA|SCRIPT|".indexOf(`|${c.tagName}|`) > 0) continue;

        // 处理切换按钮的样式（兼容原逻辑）
        if (c.className === this.zhClass) {
          if (c.id === `${this.zhClass}_${this.currentChoose}`) {
            c.style.cssText = this.styleActive;
          } else {
            c.style.cssText = this.styleInactive;
          }
          continue;
        }

        // 转换各类文本属性
        if (c.title) c.title = this.tranStr(c.title);
        if (c.alt) c.alt = this.tranStr(c.alt);
        if (c.placeholder) c.placeholder = this.tranStr(c.placeholder);

        // 转换INPUT元素的值（排除文本框、隐藏域、密码框）
        if (
          c.tagName === "INPUT" &&
          c.value &&
          !["text", "hidden", "password"].includes(c.type)
        ) {
          c.value = this.tranStr(c.value);
        }

        // 转换文本节点（nodeType=3为文本节点）
        if (c.nodeType === 3) {
          c.data = this.tranStr(c.data);
        } else {
          // 递归处理子节点
          this.zhTranBody(c);
        }
      }
    },

    // 3. 切换主方法（替代原zh_tran）
    zhTran(go, type) {
      if (go) this.currentChoose = go;
      if (go === "n") {
        // 默认语言：刷新页面（保持原逻辑）
        window.location.reload();
      } else {
        // 存储选择到sessionStorage（type!==2时）
        if (type !== 2) {
          sessionStorage.setItem("st_lang", go);
        }
        // 执行页面文本转换
        this.zhTranBody();
      }
    },

    // 4. 按钮点击事件（替代原a标签的javascript:zh_tran('t')）
    handleTran(go) {
      this.zhTran(go);
    },
  },
  created() {},
  mounted() {
    // 初始化：从sessionStorage读取上次选择的语言（替代原addLoadEvent）
    // const stLang = sessionStorage.getItem("st_lang");
    // if (stLang) {
    //   this.currentChoose = stLang;
    //   this.zhTran(stLang); // 页面加载时执行切换
    // }
  },
  watch: {},
};
</script>
<style lang="less">
.contcqhlxjfzw {
  position: fixed;
  top: 40%;
  left: 33%;
  width: 25%;
  height: 180px;
  padding: 20px;
  border: 3px solid #bd1a2d;
  background: #fff;
  color: #404040;
  z-index: 1;
  overflow: auto;
  line-height: 2;
  font-size: 14px;
  z-index: 999;
  a {
    cursor: pointer;
  }
}
header {
  .header-top {
    height: 80px;
    display: flex;
    align-items: center;
    background: #bd1a2d;
    .wrap {
      .logo {
        display: block;
        width: 460px;
      }
    }
  }
  .header-bottom {
    background: url(../assets/headerbg2.png) no-repeat;
    background-size: cover;

    .wrap {
      position: relative;
      padding-top: 50px;
      .tiantan {
        position: absolute;
        right: 0;
        bottom: 0;
        height: 95%;
      }
      h2 {
        position: relative;
        z-index: 2;
        font-size: 48px;
        font-weight: bold;
        color: #d40a2a;

        margin-bottom: 30px;
        display: flex;
        align-items: center;
        a {
          margin-left: 30px;
        }
        img {
          width: 56px;

          display: block;
          transform: translateY(5px);
        }
      }
      .search-box {
        height: 40px;
        display: flex;
        margin-bottom: 5px;
        input {
          width: 350px;
          border: 1px solid #d2d2d2;
          background: #fff;
          height: 100%;
          padding-left: 20px;
          font-size: 14px;
        }
        .search-btn {
          width: 128px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 18px;
          background: #bd1a2d;
          cursor: pointer;
        }
      }
    }
  }
}
.navTop_box {
  width: 100%;
  background: #f5f5f5;
  line-height: 40px;
  font-size: 14px;
  a {
    color: #404040;
    padding: 0 16px;
    cursor: pointer;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  }
  .R_float {
    float: right;
  }
}
@media screen and (max-width: 1024px) {
  .navTop_box {
    line-height: 32px;
    font-size: 12px;

    p {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    a {
      padding: 0 8px;
      white-space: nowrap;

      &:first-child {
        padding-left: 0;
      }
    }

    .R_float {
      float: none;
    }
  }

  header {
    .header-top {
      height: 56px;

      .wrap .logo {
        width: 240px;
        max-width: 100%;
      }
    }

    .header-bottom {
      background-size: cover;
      background-position: center;

      .wrap {
        padding-top: 16px;
        padding-bottom: 16px;

        .tiantan {
          height: 65%;
          max-width: 120px;
          opacity: 0.5;
        }

        h2 {
          font-size: 18px;
          margin-bottom: 12px;
          flex-wrap: wrap;
          line-height: 1.4;

          a {
            margin-left: 8px;

            img {
              width: 28px;
            }
          }
        }

        .search-box {
          height: 36px;
          position: relative;
          z-index: 2;
          max-width: 100%;

          input {
            flex: 1;
            width: auto;
            min-width: 0;
            padding-left: 12px;
            font-size: 13px;
          }

          .search-btn {
            width: 72px;
            flex-shrink: 0;
            font-size: 14px;
          }
        }
      }
    }
  }

  .contcqhlxjfzw {
    top: 15%;
    left: 12px;
    right: 12px;
    width: auto;
    height: auto;
    max-height: 70vh;
    padding: 16px;
    font-size: 13px;
  }
}

@media screen and (max-width: 480px) {
  .navTop_box {
    line-height: 28px;
    font-size: 11px;

    a {
      padding: 0 6px;
    }
  }

  header {
    .header-top {
      height: 48px;

      .wrap .logo {
        width: 200px;
      }
    }

    .header-bottom {
      .wrap {
        padding-top: 12px;
        padding-bottom: 12px;

        .tiantan {
          display: none;
        }

        h2 {
          font-size: 16px;
          margin-bottom: 10px;
        }

        .search-box {
          height: 34px;

          .search-btn {
            width: 64px;
            font-size: 13px;
          }
        }
      }
    }
  }
}
</style>
